import React from 'react';
import { ArrowRight, Check, ChevronRight, X } from 'lucide-react';
import { Button } from './Button';
import { everythingIncluded, finalTrust, keepDoing, noMore, openSteps, stillMatters } from '../data/offer';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-navy text-white" data-id="element-114" data-mp="c4ftoeizsnnn">
      <div className="max-w-5xl mx-auto" data-id="element-115" data-mp="844e3g5hldj1">
        <h2 className="text-3xl md:text-5xl font-display font-extrabold text-center leading-tight mb-14" data-id="element-116" data-mp="87jsegrc6ije">
          Your Next Coaching Session <span className="text-orange-light" data-id="element-117" data-mp="h6dh7kyfe4me">Is Coming Anyway.</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-118" data-mp="vui656o2ncdm">
          <div className="rounded-2xl border border-white/15 p-6 md:p-8" data-id="element-119" data-mp="vtylhi71e9vw">
            <p className="text-lg text-white/70 mb-4" data-id="element-120" data-mp="qwq59n5g8fxa">You can keep...</p>
            <ul className="space-y-2.5" data-id="element-121" data-mp="14uwru74y6thn">
              {keepDoing.map(item => <li key={item} className="flex items-start gap-3 text-white/60" data-id="element-122" data-mp="zwd1zvn8gxk0">
                  <ChevronRight size={18} className="shrink-0 mt-0.5" aria-hidden="true" data-id="element-123" data-mp="zuii8knp7bhi" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl bg-white/[0.06] border border-seafoam/40 p-6 md:p-8" data-id="element-124" data-mp="2h3zse6rlyeob">
            <p className="text-lg text-white mb-4" data-id="element-125" data-mp="2m19ilomtmud7">
              Or... you can open <span className="font-bold" data-id="element-126" data-mp="2r2yroyqhgxyn">Mountain Bike Coach Ready.</span>
            </p>
            <ul className="space-y-2.5" data-id="element-127" data-mp="2v4alzhkay7d6">
              {openSteps.map(step => <li key={step} className="flex items-start gap-3 text-white font-medium" data-id="element-128" data-mp="302c15relxmjd">
                  <Check size={18} strokeWidth={3} className="text-seafoam shrink-0 mt-0.5" aria-hidden="true" data-id="element-129" data-mp="34tlr6t42irvs" />
                  {step}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="max-w-2xl mx-auto mb-16" data-id="element-130" data-mp="3esayjryc8txs">
          <p className="font-display font-black text-xl text-center mb-5" data-id="element-131" data-mp="3epf1s6y88bax">NO MORE:</p>
          <ul className="space-y-3" data-id="element-132" data-mp="3itd0igjn3k3g">
            {noMore.map(item => <li key={item} className="flex items-start gap-3 text-lg text-white/85" data-id="element-133" data-mp="1jpel5gs2tcum">
                <X size={20} className="text-orange-light shrink-0 mt-1" aria-hidden="true" data-id="element-134" data-mp="1eq1qi9uyr1hh" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-16" data-id="element-135" data-mp="1nq6usb4v1jrf">
          <p className="text-2xl md:text-4xl font-display font-extrabold mb-2" data-id="element-136" data-mp="1nodnquqc4xiw">
            Mountain Bike Coach Ready Doesn’t Replace the Coach.
          </p>
          <p className="text-2xl md:text-4xl font-display font-extrabold text-seafoam mb-6" data-id="element-137" data-mp="1xg9mm808wro6">
            It Gives the Coach a System.
          </p>
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-1 text-lg text-white/75 mb-3" data-id="element-138" data-mp="2bezmfveg95g8">
            {stillMatters.map(line => <li key={line} data-id="element-139" data-mp="h18ceus7kjk9">{line}</li>)}
          </ul>
          <p className="text-lg text-white font-semibold" data-id="element-140" data-mp="h3kud7xyutxb">
            But now you have a complete structure behind those decisions.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-6 md:p-12 text-ink" data-id="element-141" data-mp="2x11hli66064">
          <h3 className="text-2xl font-display font-extrabold text-navy mb-6 text-center border-b border-line pb-6" data-id="element-142" data-mp="6xbh7pvrk4y6">
            EVERYTHING INCLUDED
          </h3>
          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-3 mb-12" data-id="element-143" data-mp="3p9gdj4ow8oef">
            {everythingIncluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-144" data-mp="3fdczb0grozb4">
                <Check size={18} strokeWidth={3} className="text-seafoam-dark shrink-0 mt-0.5" aria-hidden="true" data-id="element-145" data-mp="3fbtmjjubl6e3" />
                <span className="text-base text-ink" data-id="element-146" data-mp="3kad7bgx6gc4v">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-147" data-mp="3bbrrvun05d8b">
            <p className="text-2xl md:text-3xl font-display font-black text-forest" data-id="element-148" data-mp="3bct4i3jo27s5">
              MOUNTAIN BIKE COACH READY
            </p>
            <p className="text-lg text-navy font-semibold mt-1" data-id="element-149" data-mp="14j8sp3bq7a0m">
              The Complete 6-in-1 MTB Coaching System
            </p>
            <p className="text-sm text-muted mt-1 mb-8" data-id="element-150" data-mp="35o2xw6dg0i2f">
              6 Complete Volumes · 150 Ready-to-Coach Sessions · 5 Strategic Bonuses
            </p>

            <p className="text-base text-muted mb-3" data-id="element-151" data-mp="30mdkik2qzsb6">
              Built for mountain bike coaches who want to:
            </p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-1 font-display font-black text-lg md:text-xl text-navy mb-8" data-id="element-152" data-mp="2ro1xes13bcnh">
              <span data-id="element-153" data-mp="2mpql8anboq23">PLAN LESS.</span>
              <span data-id="element-154" data-mp="2mqs0ysfaa0q5">STOP IMPROVISING.</span>
              <span className="text-orange" data-id="element-155" data-mp="2hxgsynyqjdwn">KNOW WHAT TO TEACH NEXT.</span>
            </div>

            <p className="text-xl md:text-2xl font-display font-extrabold text-navy mb-2" data-id="element-156" data-mp="2cycg9nclqy1k">
              Solve an entire year of MTB coaching sessions in just{' '}
              <span className="text-orange" data-id="element-157" data-mp="27xpxaiyfusuz">5 minutes.</span>
            </p>
            <p className="text-sm font-bold tracking-wide text-forest mb-8" data-id="element-158" data-mp="23xo4z0elfbsd">
              OPEN THE SYSTEM. CHOOSE THE SKILL. START COACHING.
            </p>

            <Button className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6" data-id="element-159" data-mp="ehlhtff6i964">
              GET THE COMPLETE 6-IN-1 MTB COACHING SYSTEM NOW
              <ArrowRight size={22} aria-hidden="true" className="shrink-0" data-id="element-160" data-mp="jebxw2qzh4rj" />
            </Button>
            <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-muted" data-id="element-161" data-mp="nijltxpmagop">
              {finalTrust.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-162" data-mp="3rw8ejug6lpr1">
                  <Check size={14} strokeWidth={3} className="text-seafoam-dark" aria-hidden="true" data-id="element-163" data-mp="3rtvnmrsg451u" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-center mt-12 font-display font-extrabold text-lg text-seafoam" data-id="element-164" data-mp="4pfoo2d6xlpc">
          One System. Six Volumes. Every Stage Covered.
        </p>
      </div>
    </section>;
}